<template>
<div id="about">
    <mAbout v-if="$store.state.device == 'mob'" />
    <pAbout v-if="$store.state.device == 'pc'" />
</div>
</template>

<script>
import mAbout from '@/components/mAbout.vue'
import pAbout from '@/components/pAbout.vue'
export default {
    name: 'About',
    data (){
        return {

        }
    },
    components: {
        mAbout,
        pAbout,
    },
    computed: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>

</style>
